<form (submit)="handleSubmit($event)">
  <div class="flex items-center gap-4 px-6 pt-6 pb-5 border-b border-outline-variant">
    <div
      class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-container shrink-0"
    >
      <mat-icon class="text-on-primary-container text-[20px]! w-5! h-5!">alternate_email</mat-icon>
    </div>
    <div>
      <h2 class="text-lg font-medium leading-tight">Změnit e-mail</h2>
      <p class="text-sm text-on-surface-variant mt-0.5">
        Přihlašujete se adresou {{ currentEmail }}
      </p>
    </div>
  </div>

  <mat-dialog-content>
    <div class="flex flex-col gap-5 pb-4">
      <app-form-field-wrapper fieldName="Nový e-mail">
        <mat-form-field appearance="outline" class="w-full">
          <mat-icon matPrefix class="text-on-surface-variant mr-1">mail</mat-icon>
          <input
            matInput
            type="email"
            placeholder="jan@skola.cz"
            autocomplete="email"
            [formField]="emailForm.newEmail"
          />
          @if (emailForm.newEmail().touched() && emailForm.newEmail().invalid()) {
            <mat-error>{{ emailForm.newEmail().errors()[0].message }}</mat-error>
          }
        </mat-form-field>
      </app-form-field-wrapper>

      <app-password-field
        label="Aktuální heslo"
        autocomplete="current-password"
        prefixIcon="lock"
        [field]="emailForm.currentPassword"
      />

      <p class="text-sm text-on-surface-variant">
        Na novou adresu pošleme ověřovací odkaz. Dokud jej neotevřete, přihlašujete se původní
        adresou.
      </p>
    </div>
  </mat-dialog-content>

  <app-dialog-error-bar [message]="submission.errorMessage()" />

  <mat-dialog-actions align="end" class="border-t border-outline-variant!">
    <button matButton type="button" [disabled]="submission.isSaving()" (click)="dialogRef.close()">
      Zrušit
    </button>
    <button matButton="filled" type="submit" [disabled]="submission.isSaving()">
      @if (submission.isSaving()) {
        Odesílám…
      } @else if (canRetry()) {
        Odeslat znovu
      } @else {
        Odeslat ověřovací odkaz
      }
    </button>
  </mat-dialog-actions>
</form>
